export class InterruptError extends Error {
  constructor(message) {
    super(message); // (1)
    this.name = "InterruptError"; // (2)
  }
}
